import React, { useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, Typography
} from '@mui/material'
import { injectIntl } from 'react-intl'
import { env } from '../../env'

const stripePromise = loadStripe(env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '')
//alert(env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      '::placeholder': { color: '#aab7c4' },
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    invalid: { color: '#9e2146' }
  },
  hidePostalCode: true
}

function CardForm({ onSuccess, onError, intl }) {
  const stripe = useStripe()
  const elements = useElements()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!stripe || !elements) return

    setLoading(true)
    setError(null)

    const cardElement = elements.getElement(CardElement)
    const { error: confirmError } = await stripe.confirmCardSetup(
      onSuccess._clientSecret,
      { payment_method: { card: cardElement } }
    )

    if (confirmError) {
      setError(confirmError.message)
      if (onError) onError(confirmError.message)
      setLoading(false)
    } else {
      setLoading(false)
      if (onSuccess.callback) onSuccess.callback()
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ padding: '16px 0', border: '1px solid #e0e0e0', borderRadius: 4, padding: 16, marginBottom: 16 }}>
        <CardElement options={CARD_ELEMENT_OPTIONS} />
      </div>
      {error && (
        <Typography color="error" variant="body2" style={{ marginBottom: 8 }}>
          {error}
        </Typography>
      )}
      <DialogActions>
        <Button onClick={onSuccess.onClose} color="primary" disabled={loading}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button type="submit" variant="contained" color="primary" disabled={!stripe || loading}>
          {loading ? <CircularProgress size={24} /> : intl.formatMessage({ id: 'confirm' })}
        </Button>
      </DialogActions>
    </form>
  )
}

function StripeCardFormDialog({ open, onClose, clientSecret, onSuccess, onError, intl }) {
  if (!clientSecret) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{intl.formatMessage({ id: 'billing.add.card' })}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          {intl.formatMessage({ id: 'billing.add.card.description' })}
        </Typography>
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CardForm
            intl={intl}
            onSuccess={{ _clientSecret: clientSecret, callback: onSuccess, onClose }}
            onError={onError}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  )
}

export default injectIntl(StripeCardFormDialog)
